import Glide from "@glidejs/glide";
import { getElement, getElements, ifSelectorExist } from "./utils";

export const autoAccidentSliders = () => {
  const caseResultsSlider = ".case_results_slider";
  const caseResultsSliderEL = getElements(caseResultsSlider);
  console.log('caseResultsSliderEL == ', caseResultsSliderEL);
  if (ifSelectorExist(caseResultsSliderEL)) {
    Array.from(caseResultsSliderEL).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 3,
        autoplay: 2500,
        animationduration: 2000,
        type: "carousel",
        breakpoints: {
          992: {
            perView: 2,
          },
          640: {
            perView: 1.25,
          },
        },
      }).mount();
    });
  }

  const dealersMobileSlider = ".dealers_mobile_slider";
  const dealersMobileSliderEl = getElements(dealersMobileSlider);
  if (ifSelectorExist(dealersMobileSliderEl)) {
    Array.from(dealersMobileSliderEl).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 3.5,
        type: "carousel",
      }).mount();
    });
  }

  const reviewsMobileSlider = ".reviews_mobile_slider";
  const reviewsMobileSliderEl = getElements(reviewsMobileSlider);

  if (ifSelectorExist(reviewsMobileSliderEl)) {
    Array.from(reviewsMobileSliderEl).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 1,
        type: "carousel",
      }).mount();
    });
  }

  const teamBlockSlider = ".team_block_slider";
  const teamBlockSliderEl = getElements(teamBlockSlider);

  if (ifSelectorExist(teamBlockSliderEl)) {
    Array.from(teamBlockSliderEl).forEach((item) => {
      new Glide(item, {
        gap: 16,
        type: "carousel",
        perView: 4,
        breakpoints: {
          1280: {
            perView: 3,
          },
          1024: {
            perView: 2,
          },
          640: {
            perView: 1,
          },
        },
      }).mount();
    });
  }
};